import styled from 'styled-components';

export const Description = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.secondary};
`;
